import React, { Component } from "react";
import { connect } from 'react-redux';
import { setLiman, turkLimanlariniListele, onCheckBoxChange } from "../../actions/Actions";
import { Checkbox } from "react-bootstrap";

class LimanDropDown extends Component {
    componentDidMount() {
        const { willGetAll } = this.props;

        this.props.turkLimanlariniListele(willGetAll);
    }

    render() {
        const { limanlar, willGetAll } = this.props;

        return (
            <div>
                <select defaultValue="0" className="form-control" onChange={(e) => this.props.setLiman(e.target.value)} >
                    <option value="0" disabled>Select...</option>
                    {limanlar.map((each, i) => {
                        return (
                            <option key={i} value={each.id}>{each.name}</option>
                        )
                    })}
                </select>
                <Checkbox onChange={() => this.props.onCheckBoxChange(!willGetAll)} checked={willGetAll} >Tümü</Checkbox>
            </div >
        )
    }
}

const mapStateToProps = state => ({
    limanlar: state.reducer.limanlar,
    willGetAll: state.reducer.willGetAll
});

const mapDispatchToProps = dispatch => ({
    setLiman: (limanId) => { setLiman(dispatch, limanId); },
    turkLimanlariniListele: (willGetAll) => { turkLimanlariniListele(dispatch, willGetAll); },
    onCheckBoxChange: (willGetAll) => { onCheckBoxChange(dispatch, willGetAll); }
});

export default connect(mapStateToProps, mapDispatchToProps)(LimanDropDown);


// WEBPACK FOOTER //
// ./src/components/containers/LimanDropDown.js